//customer review
const reviews = [
  {
    name: "iuliia ChebotarevaN",
    comment:
      "Maria is Amazing person. Great prices for laser hair removal and visible results. Very easy book appointment and location very close to subway and buses.",
  },
  {
    name: "Sadhi Bat",
    comment:
      "Me daugher have done some laser sessions at XBUTY Laser and the service is fantastic! Everyone is super friendly and professional. The location is clean, bright, and very welcoming. I highly recommend this place for their services offered.",
  },
  {
    name: "Candice Sooknanan",
    comment:
      "Excellent service and prices. Maria's kindness and patience makes you feel comfortable during your procedures. She is always will to go the extra mile and accommodate her clients. Facility is clean and professional. She has transformed my skin and I get numerous compliments. I cant thank her enough!",
  },
  {
    name: "Sulmaz RM",
    comment:
      "If you check my reviews you will see I am not easily satisfied.Years ago After my research I choosed this place based on the positive reviews I saw here... As you may see sometimes you go to place after  reading reviews and see nothing is real, but this one is truly amazing experience for me.",
  },
  {
    name: "inu",
    comment:
      "Marya has an Maria is GREAT with laser. She knows what she's doing, she is very very attentive with pain, gives recommendations to reduce pains and is very patient with me during the procedure. I have gone twice and have 4 more sessions to go, but I am already seeing how effective it is! personally and you can clearly see she loves what she does. Knowledgeable and educated. You will receive extra efforts and care for service u asking for. I believe what she charges is worth the service we get. Not comparable with other places. Approved modern machines and high quality products. She is always willing to share her knowledge about any beauty questions you have.",
  },
  {
    name: "Aswathy Vijayakumar",
    comment:
      "Marya has an amazing Maria is very professional, pleasant and she made me so comfortable during my laser sessions. I had taken 6 sessions for facial hair removal and after the third one I could really see great and effective results. It is really worth the money spent for the package. The sessions were really quick and easy to handle. I would definitely recommend her any day. and you can clearly see she loves what she does. Knowledgeable and educated. You will receive extra efforts and care for service u asking for. I believe what she charges is worth the service we get. Not comparable with other places. Approved modern machines and high quality products. She is always willing to share her knowledge about any beauty questions you have.",
  },
  {
    name: "Sulmaz RM",
    comment:
      "Marya has an amazing personally and you can clearly see she loves what she does. Knowledgeable and educated. You will receive extra efforts and care for service u asking for. I believe what she charges is worth the service we get. Not comparable with other places. Approved modern machines and high quality products. She is always willing to share her knowledge about any beauty questions you have.",
  },
];

export default reviews;
